module.exports = __webpack_public_path__ + "img/ticket_star.f4a9b56b.svg";